/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Modal } from "react-bootstrap";
import L from "./Lang"
import BaseCom from "./BaseCom";
import { qreq } from "../shared/qrequest";

export default class SandboxModal extends BaseCom {

    componentDidMount() {
        qreq.get('/api/data/sandbox/mode', j => {
            if (j.item)
                this.setState({ show: true });
        });
    }

    render() {
        return; //tmp
        return <Modal show={this.state.show} onHide={() => this.setState({ show: false })} size="lg">

            <Modal.Header closeButton>
                <Modal.Title><L>Staging Instance</L></Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <p><L>This instance is running on the staging pipeline. It receives updates before production.</L></p>
            </Modal.Body>

            <Modal.Footer>
                <button className="btn btn-primary" onClick={() => this.setState({ show: false })}>Close</button>
            </Modal.Footer>
        </Modal>;
    }
}